module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "title-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815070_toc01#toctitle4",
      "id": "title4"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-chapter"
  }, [_vm._v("SATURDAY EVENING, 6:30 P.M.")]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("O")]), _vm._v("n the way back to his van, the driver picked at some french fries in a cardboard container. Sucking up the last one, he let the red and yellow box drop to the ground. He started the van and moved it forward a few yards. He got out to check the hole. It was still there. Unlocking the back doors, the driver climbed inside. He reemerged with the slight body of a woman slung over his shoulders in the traditional fireman’s grip. Before climbing down, his eyes darted around the enclosure. The space was empty and, except for the shush of traffic at the other end of the alley, it was quiet.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Bending down, he eased the body slowly into the hole. Despite his care, the head, arms, and legs flopped like a doll’s. With one hand, he jerked the body upright into a sitting position. Then, with both hands, he shoved it backward until it rested against the back of the hole. The torso remained vertical, but the head persisted in lolling to one side. With a curse, he reached for the spade and began tossing chunks of earth into the body’s lap. He paused, spade in midair. Letting the spade fall, he climbed back into the van. When he reappeared, he held a small canvas\nbag in one hand. Shoving it roughly down beside the body, he continued to fill up the hole.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("A rustle. He spun around.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("A pigeon waddled toward him out of the dark. He feinted hitting it with the spade and went back to his work. When he had finished, the rectangle of earth looked like a flower bed waiting for tulip and daffodil bulbs.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("As the driver nosed the van out of the alley into the street, he noticed that all the passing cars had their headlights turned on. The job had taken longer than he thought. He might have to jack up the price.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49b153fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466815070_c03.vue
// module id = 75
// module chunks = 0